// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Jurnal Amigo',
  intro:
    'Fiecare solicitare gestionată de Amigo: ce s-a cerut, unde, cine a cerut și cine a aprobat. Doar FoodAmigos vede această pagină.',
  // The tab list's name for screen readers.
  tabs_label: 'Jurnal Amigo',
  tabs: {
    requests: 'Solicitări',
    gaps: 'Nerealizabile',
  },
  filters: {
    restaurant: 'Restaurant',
    all_restaurants: 'Toate restaurantele',
    brand: '{{name}} · Brand',
    restaurant_unknown: 'Restaurant {{id}}',
    searching: 'Se caută restaurante…',
    no_restaurant: 'Niciun restaurant numit „{{query}}”',
    period: 'Perioadă',
    start_date: 'Data de început',
    end_date: 'Data de sfârșit',
    refresh: 'Reîmprospătează',
    gap: 'Cerut: {{request}}',
    change_set: 'Solicitarea din spatele unei modificări',
    remove: 'Elimină filtrul: {{label}}',
    clear: 'Șterge filtrele',
  },
  columns: {
    steps: 'Pași',
    when: 'Când',
    request: 'Solicitare',
    restaurant: 'Restaurant',
    asked_by: 'Cerută de',
    result: 'Rezultat',
  },
  show_steps: 'Afișează pașii pentru: {{request}}',
  approved_by: 'Aprobat de {{name}}',
  nothing_approved: 'Nimic aprobat',
  results: {
    applied: '{{applied}} aplicate',
    applied_skipped: '{{applied}} aplicate · {{skipped}} omise',
    partial: '{{applied}} din {{total}} aplicate',
    imported: 'Importat',
    importing: 'Se importă',
    waiting: 'Se așteaptă aprobarea',
    rejected: 'Respinsă',
    undone: 'Anulată',
    expired: 'Expirat',
    replaced: 'Înlocuită',
    failed: 'Eșuată',
    answered: 'Răspuns dat',
    not_yet: 'Încă nerealizabil',
    off_limits: 'Interzis',
    not_allowed: 'Nepermis',
    switched_off: 'Dezactivat',
    guard: 'Oprit de o verificare de siguranță',
    not_found: 'Negăsit',
  },
  steps: {
    asked: '{{name}} a cerut',
    asked_anonymous: 'Cerută',
    approved: 'Aprobat de {{name}}',
    approved_alone: 'Aprobată',
    applied_one: '{{count}} modificare aplicată',
    applied_few: '{{count}} modificări aplicate',
    applied_other: '{{count}} de modificări aplicate',
    failed_one: '{{count}} neaplicate',
    failed_few: '{{count}} neaplicate',
    failed_other: '{{count}} neaplicate',
    rejected: 'Respinsă',
    undone: 'Anulată',
    skipped_one: '{{count}} omise',
    skipped_few: '{{count}} omise',
    skipped_other: '{{count}} omise',
    skipped_state: 'Omis',
    more_one: 'și încă {{count}}',
    more_few: 'și încă {{count}}',
    more_other: 'și încă {{count}}',
    changes_one: '{{count}} modificare',
    changes_few: '{{count}} modificări',
    changes_other: '{{count}} de modificări',
    other: 'Verificare în curs',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} pas',
    steps_few: '{{count}} pași',
    steps_other: '{{count}} de pași',
    refused_one: '{{count}} refuzate',
    refused_few: '{{count}} refuzate',
    refused_other: '{{count}} refuzate',
    failed_one: '{{count}} eșuate',
    failed_few: '{{count}} eșuate',
    failed_other: '{{count}} eșuate',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Rezultat',
    answered: 'Un răspuns: nimic nu s-a schimbat.',
    waiting: 'Se așteaptă aprobarea. Încă nu s-a schimbat nimic.',
    rejected: 'Respins: nimic nu s-a schimbat.',
    expired: 'Expirat fără aprobare: nimic nu s-a schimbat.',
    replaced: 'Înlocuit de un card mai nou: aici nu s-a schimbat nimic.',
    undone: 'Anulat: modificările au fost reversate.',
    failed: 'Eșuat: nimic nu s-a schimbat.',
    not_yet: 'Încă nu s-a putut face: nimic nu s-a schimbat. Numărat la „Nu s-a putut face”.',
    off_limits: 'Interzis: nimic nu s-a schimbat.',
    not_allowed: 'Nepermis pentru rolul acestei persoane: nimic nu s-a schimbat.',
    switched_off: 'Dezactivat aici: nimic nu s-a schimbat.',
    guard: 'Oprit de o verificare de siguranță: nimic nu s-a schimbat.',
    not_found: 'Negăsit: nimic nu s-a schimbat.',
    importing: 'Se importă. Fiecare preparat ajunge în Meniu → Istoricul modificărilor.',
    imported: 'Importat. Fiecare preparat este în Meniu → Istoricul modificărilor.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} modificare',
    title_few: '{{count}} modificări',
    title_other: '{{count}} de modificări',
    show_all: 'Afișează toate cele {{count}} de modificări',
    show_fewer: 'Afișează mai puține',
    from: 'din',
    to: 'în',
    removed: 'Eliminat',
  },
  row_states: {
    skipped: 'Omis',
    failed: 'Neaplicat',
    stale: 'Modificat între timp',
    kept: 'Lăsat neschimbat',
  },
  menu_history: 'Deschide Meniu → Istoric modificări',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Deschide chatul',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: 'Nu am putut deschide acest restaurant. Încearcă din nou.',
  pagination: {
    label: 'Pagini',
    summary: '{{from}}–{{to}} din {{total}} solicitări',
    previous: 'Pagina anterioară',
    next: 'Pagina următoare',
  },
  empty: {
    title: 'Nicio solicitare pentru {{restaurant}} în această perioadă',
    text: 'Amigo nu a gestionat nimic acolo între {{from}} și {{to}}.',
    title_any_day: 'Încă nicio solicitare pentru {{restaurant}}',
    text_any_day: 'Amigo nu a gestionat încă nimic acolo.',
    title_everywhere: 'Nicio solicitare în această perioadă',
    text_everywhere: 'Amigo nu a gestionat nimic între {{from}} și {{to}}.',
    title_nothing: 'Încă nicio solicitare',
    text_nothing: 'Amigo nu a gestionat încă nimic.',
  },
  loading: 'Se încarcă…',
  error: {
    title: 'Jurnalul nu a putut fi încărcat',
    text: 'Încearcă din nou peste puțin timp.',
    retry: 'Încearcă din nou',
  },
  gaps: {
    intro:
      'Ce nu a putut face Amigo încă, grupat după ce s-a cerut, cele mai frecvente primele. Solicitările interzise și cele nepermise unui rol nu apar aici.',
    columns: {
      area: 'Domeniu',
      request: 'Ce au cerut oamenii',
      count: 'Cerută',
      last_at: 'Ultima cerere',
      requests: 'Solicitări',
    },
    count: '{{count}}×',
    see_requests_one: 'Vezi {{count}} solicitare',
    see_requests_few: 'Vezi {{count}} solicitări',
    see_requests_other: 'Vezi {{count}} de solicitări',
    today: 'Azi, {{time}}',
    yesterday: 'Ieri, {{time}}',
    empty_title: 'Nicio solicitare pe care Amigo nu a putut-o îndeplini',
    empty_text: 'Tot ce au cerut oamenii, Amigo a putut face.',
  },
  areas: {
    menu: 'Meniu',
    hours: 'Program de funcționare',
    order_settings: 'Setări comenzi',
    my_info: 'Informațiile mele',
    marketing: 'Marketing',
    gift_cards: 'Carduri cadou',
    reports: 'Rapoarte',
    website: 'Site web',
    integrations: 'Integrări',
    delivery: 'Livrare',
    payments: 'Plăți',
    team: 'Echipă',
    billing: 'Facturare',
    settings: 'Setări',
    other: 'Altele',
  },
};
